import React from 'react';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import brand from '../../../utils/brand';
import logo from '../../../../static/images/logo-televisa.svg';
import styles from './../../../components/App/appStyles-jss';
import Login from './../Users/Login';

class LoginDedicated extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.appFrameOuter}>
        <main className={classes.outerContent} id="mainContent">
          <Hidden xsUp>
            <div className={classes.brandMovil}>
              <img src={logo} alt={brand.name} />
            </div>
          </Hidden>
          <Login />
        </main>
      </div>
    );
  }
}

LoginDedicated.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default (withStyles(styles)(LoginDedicated));
